export { default } from './FooterDesktopPMD';